/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useState} from 'react'
import {Dropdown, FormControl, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {getListEconMember} from '../../app/pages/national/fta-impact/core/_requests'
import useAxiosPrivate from '../../app/libs/useAxiosPrivate'
import {getParentChapters} from '../../app/pages/admin/trade-data-agreement-chapter-new/core/_requests'

type EconDropdownProps = {
  onSelect: (parent: any) => void
  disabled?: boolean
  originalParent?: any
  idAgreement?: string | null | undefined
}

type selectedParentType = {
  id: string
  label: string
  title: string
}

const RTAContentParentDropdown: FC<EconDropdownProps> = ({
  onSelect,
  disabled = false,
  originalParent,
  idAgreement,
}) => {
  const axiosPrivate = useAxiosPrivate()
  const [contentParents, setContentParents] = useState<Array<any> | null>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [selectedContentParent, setSelectedContentParent] = useState<selectedParentType>()
  const [filteredContentParent, setFilteredContentParent] = useState<Array<any>>([])

  const buildHierarchicalList = (items: Array<any>) => {
    const tree: any[] = []
    const lookup: any = {}

    items.forEach((item) => {
      lookup[item.id] = {...item, children: []}
    })

    items.forEach((item) => {
      if (item.parent_id && lookup[item.parent_id]) {
        lookup[item.parent_id].children.push(lookup[item.id])
      } else {
        tree.push(lookup[item.id])
      }
    })

    const flatten = (nodes: Array<any>): Array<any> => {
      let flat: Array<any> = []
      nodes.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      nodes.forEach((node) => {
        flat.push(node)
        if (node.children && node.children.length > 0) {
          flat = flat.concat(flatten(node.children))
        }
      })
      return flat
    }

    return flatten(tree).map((item) => {
      const {children, ...rest} = item
      return rest
    })
  }

  useEffect(() => {
    getParentChapters(axiosPrivate, {idAgreement})
      .then((res) => {
        const sortedData = buildHierarchicalList(res.data.data)
        setContentParents(sortedData)
        setFilteredContentParent(sortedData)
      })
      .catch((e) => {
        console.error(e)
      })
  }, [])

  useEffect(() => {
    setFilteredContentParent(filteredContentParent!)
  }, [filteredContentParent, originalParent])

  useEffect(() => {
    if (!originalParent) {
      setSelectedContentParent(undefined)
      return
    }

    const found = contentParents?.find((e) => e.id === originalParent)
    setSelectedContentParent(found)
  }, [originalParent, contentParents])

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setSearchTerm(value)
    const filteredEcon = contentParents?.filter(
      (parent) =>
        parent.label.toLowerCase().includes(value.toLowerCase()) ||
        parent.title.toLowerCase().includes(value.toLowerCase())
    )
    setFilteredContentParent(filteredEcon!)
  }

  const removeSearchTerm = () => {
    setSearchTerm('')
    setFilteredContentParent(contentParents!)
  }

  const getLevel = (parentId: any): number => {
    let level = 0
    let currentParentId = parentId
    while (currentParentId && level < 10) {
      level += 1
      const parent = contentParents?.find((p) => p.id == currentParentId)
      currentParentId = parent?.parent_id
    }
    return level
  }

  const handleSelect = (parent: any) => {
    onSelect(parent.id)
    setSelectedContentParent({
      id: parent.id,
      label: parent.label,
      title: parent.title,
    })
  }

  const dropdownItem = filteredContentParent?.map((parent) => {
    const level = getLevel(parent.parent_id)
    return (
      <Dropdown.Item
        key={parent.id}
        role='menuitem'
        size='sm'
        onClick={() => handleSelect(parent)}
        title={parent.title}
        style={{paddingLeft: `${0.5 + level * 1}rem`}}
      >
        {parent.label}&nbsp;({parent.title})
      </Dropdown.Item>
    )
  })

  return (
    <Dropdown onToggle={removeSearchTerm}>
      <Dropdown.Toggle
        variant='label-dropdown'
        id=''
        className='btn btn-bold btn-sm dropdown-toggle fw-normal text-start w-100'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '44px',
        }}
        disabled={disabled}
      >
        {selectedContentParent ? (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'clip',
              maxWidth: '300px',
            }}
          >
            {selectedContentParent.label}&nbsp;({selectedContentParent.title})
          </div>
        ) : (
          'Select Content Parent'
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-econ-menu w-100'>
        <FormControl
          type='text'
          size='sm'
          placeholder='Search...'
          className='dropdown-econ-search-bar'
          value={searchTerm}
          onChange={handleSearch}
          style={{}}
        />
        {dropdownItem}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default RTAContentParentDropdown
